import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { cardStyle, CardDecorations } from './dashboardStyles';

interface QuickLink {
  icon: string;
  title: string;
  desc: string;
  path: string;
}

const QUICK_LINKS: QuickLink[] = [
  { icon: '🌟', title: 'Натальная карта', desc: 'Узнай свои планетарные позиции', path: '/natal' },
  { icon: '🔢', title: 'Нумерология', desc: 'Число жизненного пути и судьба', path: '/numerology' },
  { icon: '📅', title: 'Прогнозы', desc: 'Персональные прогнозы на период', path: '/forecasts' },
  { icon: '💞', title: 'Совместимость', desc: 'Анализ отношений с партнёром', path: '/compatibility' },
  { icon: '✨', title: 'Спецанализы', desc: 'Таланты, карма, предназначение', path: '/analyses' },
  { icon: '📰', title: 'Статьи', desc: 'Полезные материалы по астрологии', path: '/articles' },
];

const DashboardQuickActions: React.FC = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ marginBottom: '32px' }}>
      <h2 style={{
        color: '#f0f0f0',
        fontSize: isMobile ? '19.2px' : '24px',
        fontFamily: 'var(--font-display)',
        fontStyle: 'italic',
        marginBottom: '24px',
      }}>
        🚀 Быстрый доступ
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
        gap: '20px',
      }}>
        {QUICK_LINKS.map((link) => (
          <div
            key={link.title}
            onClick={() => navigate(link.path)}
            style={{
              ...cardStyle,
              padding: isMobile ? '20px 16px' : '24px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.5)';
              e.currentTarget.style.transform = 'translateY(-4px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.12)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <CardDecorations />
            <div style={{ fontSize: '32px', marginBottom: '12px', position: 'relative', zIndex: 1 }}>
              {link.icon}
            </div>
            <div style={{
              color: '#f0f0f0',
              fontSize: isMobile ? '14.4px' : '18px',
              fontWeight: 600,
              marginBottom: '8px',
              fontFamily: 'var(--font-display)',
              position: 'relative',
              zIndex: 1,
            }}>
              {link.title}
            </div>
            <div style={{
              color: '#b0b0b0',
              fontSize: isMobile ? '11.2px' : '14px',
              lineHeight: 1.5,
              position: 'relative',
              zIndex: 1,
            }}>
              {link.desc}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardQuickActions;
